import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom"

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

import RootPage from "./pages/RootPage"
import KeuzewijzerPage from "./pages/keuzewijzerpages/KeuzewijzerPage"
import BtwtoolPage from "./pages/btwtoolpages/BtwtoolPage"
import VennootschapOfNietPage from "./pages/vonpages/VennootschapOfNietPage"

import './App.css'

const params = new URLSearchParams(window.location.search)

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: params.get("language") ?? "en",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already protects against xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

const router = createBrowserRouter([
  { path: "/", element: <RootPage /> },
  { path: "/keuzewijzer", element: <KeuzewijzerPage /> },
  { path: "/btwtool", element: <BtwtoolPage /> },
  { path: "/vennootschapofniet", element: <VennootschapOfNietPage /> },
])

const App = () => {

  const [stylesheet, setStylesheet] = useState("istart.css")

  useEffect(() => {

    if (process.env.REACT_APP_COMPANY == "istart") {
      setStylesheet("./istart.css")
    } else {
      setStylesheet("./partena.css")
    }

    var head = document.head;
    var link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = stylesheet;

    head.appendChild(link);

    return () => { head.removeChild(link); }

  }, [stylesheet])

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  )
}

export default App
